<template>
  <div v-if="text.length">
    <v-btn outlined x-small @click="sendVoiceMsg">
      {{ $t("testVoice") }}
    </v-btn>
    <Tooltip>
      <template v-slot:content>
        <p>
          {{ $t("youWillRecCall", { mobile: usrMobile }) }}
        </p>
        <p>
          {{ $t("youWillRecMsgVoiceLimitations") }}
        </p>
      </template>
    </Tooltip>
  </div>
</template>

<script>
import Tooltip from "@/components/misc/Tooltip";
import store from "@/store";
import apiVoice from "@/api/v24/api.voice";
import appSnackbar from "@/util/appSnackbac";

export default {
  name: "TestVoiceText",
  components: { Tooltip },

  props: {
    text: {
      required: true,
      type: String
    },
    voicePerson: {
      required: true,
      type: String
    }
  },

  data: () => ({
    usrMobile: ""
  }),

  created() {
    store.dispatch("updateUserProfile").then(usrProfile => {
      this.usrMobile = usrProfile.Bruker.Mobilnr;
    });
  },

  methods: {
    sendVoiceMsg() {
      apiVoice
        .sendSingle(this.usrMobile, this.text, this.voicePerson)
        .then(() => {
          appSnackbar.setMessage(this.$t("testMessageSent"));
        })
        .catch(() => {
          appSnackbar.setMessage(this.$t("testMessageFailed"));
        });
    }
  }
};
</script>
